import './App.css';
import Raffles from './pages/raffles'
import RafflesDetails from './pages/raffleDetails'
import './css/raffles.scss'
import { HashRouter as BrowserRouter, Route, Routes } from 'react-router-dom';
import { useMemo } from 'react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base'
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import {
  GlowWalletAdapter,
  PhantomWalletAdapter,
  SlopeWalletAdapter,
  SolletWalletAdapter,
  SolflareWalletAdapter
} from '@solana/wallet-adapter-wallets';
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { Connection } from '@solana/web3.js';
import '@solana/wallet-adapter-react-ui/styles.css';
import RafflesProvider from './contexts/Providers';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
  const network = WalletAdapterNetwork.Mainnet;

  // You can also provide a custom RPC endpoint.
  // const endpoint = useMemo(() => clusterApiUrl(network), [network]);
  // const endpoint = useMemo(()=> "https://api.metaplex.solana.com/", []);
  const endpoint = useMemo(()=> "https://solana-api.syndica.io/access-token/6ij3GK1oDRsecXudDTuFDmiOFFs3b9xpjyg6JOAxFuBwuAZITl4yGjzV7rZoyMKD/rpc", []);
  // const endpoint = useMemo(()=>"https://api.devnet.solana.com/", []);

  // New Connection
  const connection = useMemo(() => new Connection(endpoint), [endpoint]);

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new GlowWalletAdapter(),
      new SlopeWalletAdapter(),
      new SolflareWalletAdapter({ network }),
      new SolletWalletAdapter()
    ],
    [network]
  );

  return (
    <ConnectionProvider endpoint={ endpoint }>
      <WalletProvider wallets={ wallets } autoConnect>
        <WalletModalProvider>
          <RafflesProvider connection={ connection } >
            <BrowserRouter>
              <Routes>
                <Route path="/raffle-details/:key" element={ <RafflesDetails /> } />
                <Route path="/" element={ <Raffles /> } />
              </Routes>
            </BrowserRouter>
            <div>
              <ToastContainer
                position='bottom-left'
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </div>
          </RafflesProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;
